import { fromJS } from 'immutable';

import { combineReducerArray } from 'reducers/utils/helpers';

import { fundingReport, inviteLink } from './types';
import fundingReportListReducer from './list/reducer';
import fundingReportMatchesReducer from './matches/reducer';
import deleteFundingReportReducer from './delete/reducer';
import resendInviteReducer from './resendInvite/reducer';

export * from './actions';

const initialState = fromJS({
  all: {
    ids: [],
    network: {
      loading: false,
      error: false,
    },
  },
  byId: {},
  data: {},
  deleteFundingReport: {
    fundingReport: false,
    modalOpen: false,
    network: {
      loading: false,
      error: false,
      success: false,
    },
  },
  inviteLink: {
    data: false,
    network: {
      loading: false,
      error: false,
    },
  },
  matches: {
    data: [],
    network: {
      loading: false,
      error: false,
      success: false,
    },
  },
  network: {
    loading: false,
    error: false,
    success: false,
  },
  resendInvite: {
    network: {
      loading: false,
      error: false,
      success: false,
    },
  },
});

const fundingReportReducer = {
  [fundingReport.failure]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'error'], true)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'success'], false),
    ),
  [fundingReport.request]: (state) =>
    state.withMutations((currentState) =>
      currentState.setIn(['network', 'loading'], true).setIn(['network', 'success'], false),
    ),
  [fundingReport.success]: (state, { response }) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['data'], response)
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'success'], true)
        .setIn(['resendInvite', 'network', 'error'], false)
        .setIn(['resendInvite', 'network', 'loading'], false)
        .setIn(['resendInvite', 'network', 'success'], false),
    ),

  [inviteLink.request]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['inviteLink', 'network', 'loading'], true)
        .setIn(['inviteLink', 'sent'], false),
    ),
  [inviteLink.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['inviteLink', 'network', 'loading'], false)
        .setIn(['inviteLink', 'network', 'error'], false)
        .setIn(['inviteLink', 'data'], action.response),
    ),
  [inviteLink.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['inviteLink', 'network', 'loading'], false)
        .setIn(['inviteLink', 'network', 'error'], action.error)
        .setIn(['inviteLink', 'data'], false),
    ),
};

export default combineReducerArray(initialState, [
  deleteFundingReportReducer,
  fundingReportListReducer,
  fundingReportMatchesReducer,
  fundingReportReducer,
  resendInviteReducer,
]);
